import React, {useCallback, useState} from 'react'
import {
    IEnterprisesType,
    EnterprisesTypesInitValues as initialValues,
} from '../../models/EnterprisesTypesModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {registerPlugin} from 'react-filepond'

import {Input3, Input} from '../../../../../../components/Forms/Input'
import 'filepond/dist/filepond.min.css'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
import {Toolbar2} from "../../../../../../_metronic/layout/components/toolbar/Toolbar2";
import {PageTitle} from "../../../../../../_metronic/layout/core";
import {useDropzone} from 'react-dropzone'
import {AnimaBaixo} from "../../../../../../_metronic/assets/animation/styles";
import {KTSVG, toAbsoluteUrl} from "../../../../../../_metronic/helpers";
import withReactContent from "sweetalert2-react-content";

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview)

const API_URL = process.env.REACT_APP_API_URL || 'api'

const FormEnterprisesTypeAdd: React.FC = () => {
    const intl = useIntl()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const [file, setFile] = useState<File>(new File([], ''));
    const [active, setActive] = useState<boolean>(false)
    const onDrop = useCallback((acceptedFiles: any) => {
        setActive(true)
        setFile(acceptedFiles[0])
        formik.setFieldValue('image', acceptedFiles[0])
    }, [])

    const enterprisesTypesSchema = Yup.object().shape({
        name: Yup.string().required(intl.formatMessage({id: 'AUTH.VALIDATION.REQUIRED_FIELD'})),
        description: Yup.string().required(intl.formatMessage({id: 'AUTH.VALIDATION.REQUIRED_FIELD'})),
    })

    function deleteFile() {
        const MySwal = withReactContent(Swal)

        MySwal.fire({
            title: intl.formatMessage({id: 'COMMON.SWAL_DELETE_FILE'}),
            text: intl.formatMessage({id: 'COMMON.SWAL_DELETE_TEXT'}),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: intl.formatMessage({id: 'COMMON.SWAL_DELETE_MSG'}),
            cancelButtonText: intl.formatMessage({id: 'COMMON.CANCEL_BUTTON'}),
        }).then((result) => {
                    setActive(false)
        })
    }

    const {getRootProps, getInputProps, isDragActive, acceptedFiles} = useDropzone({onDrop})
    const files = acceptedFiles.map((file: any) => (
        <AnimaBaixo>
                <>
                    <div className='row mt-10 dropzone'>
                        <div className='col-lg-11'>
                                <p className=' d-flex align-items-center position-relative'>
                                    <img alt='' className='w-30px me-3' src={toAbsoluteUrl('/media/svg/files/upload.svg')} />{' '}
                                    {file.name} <span className='text-gray-600'>- {file.size} bytes</span>
                                </p>
                        </div>
                        <div className='col-lg-1'>
                            <button
                                type='button'
                                title='Excluir Arquivo'
                                onClick={() => deleteFile()}
                                className='btn btn-sm btn-icon btn-icon-danger p-3 ms-3'
                            >
                                <KTSVG
                                    path='/media/icons/duotune/general/gen027.svg'
                                    className='svg-icon-1'
                                />
                            </button>
                        </div>
                    </div>
                </>

        </AnimaBaixo>
    ))

    const data = new FormData()
    const formik = useFormik<IEnterprisesType>({
        initialValues,
        validationSchema: enterprisesTypesSchema,
        onSubmit: async (values) => {
            setLoading(true)

            try {
                data.append('name', values.name)
                data.append('description', values.description)

                if (values.icon_width) data.append('icon_width', values.icon_width.toString())

                if (values.icon_height) data.append('icon_height', values.icon_height.toString())

                if (values.image) {
                    data.set('image', values.image as File)
                }

                if (values.generate_production) {

                    data.append('generate_production', '1')
                } else if (!values.generate_production) {

                    data.append('generate_production', '0')
                }


                //await axios.post(API_URL + '/v1/enterprise_types', values)
                await axios({
                    method: 'post',
                    url: API_URL + '/v1/enterprise_types',
                    data: data,
                    headers: {'Content-Type': 'multipart/form-data'},
                })
                setLoading(false)
                Swal.fire({
                    icon: 'success',
                    title: intl.formatMessage({id: 'ENTERPRISE_TYPE.SWAL_ADD'}),
                    showConfirmButton: false,
                    timer: 2000,
                })
                navigate('/enterprises_type')
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: intl.formatMessage({id: 'ENTERPRISE_TYPE.SWAL_ADD_ERROR'}),
                    showConfirmButton: false,
                    timer: 2000,
                })

                setLoading(false)
            }
        },
    })

    function resetInputs() {
        formik.resetForm()
    }

    return (
        <div className='card card-custom mt-n8'>

            {/* INICIO HEADER */}
            <Toolbar2 icon={false} subtitle={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})}/>
            <PageTitle breadcrumbs={[]}>
                {intl.formatMessage({id: 'ENTERPRISE_TYPE.TITLE_ADD'})}
            </PageTitle>
            {/* FIM HEADER */}

            <div id='kt_account_profile_details' className='collapse show'>
                <form onSubmit={formik.handleSubmit} noValidate className='form'>
                    <div className='card-body border-top p-9'>

                        {/* INICIO NOME */}
                        <Input3
                            title={intl.formatMessage({id: 'COMMON.INPUT_NAME'})}
                            placeholder={intl.formatMessage({id: 'COMMON.INPUT_NAME_PLACEHOLDER'})}
                            {...formik.getFieldProps('name')}
                            required

                        />
                        {formik.touched.name && formik.errors.name && (
                            <div className='fv-plugins-message-container text-danger'>
                                <div className='fv-help-block'>{formik.errors.name}</div>
                            </div>
                        )}
                        {/* FIM NOME */}

                        {/* INICIO DESCRIÇÃO */}
                        <Input3
                            title={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                            placeholder={intl.formatMessage({id: 'COMMON.INPUT_DESCRIPTION_PLACEHOLDER'})}
                            {...formik.getFieldProps('description')}
                            required
                        />
                        {formik.touched.description && formik.errors.description && (
                            <div className='fv-plugins-message-container text-danger'>
                                <div className='fv-help-block'>{formik.errors.description}</div>
                            </div>
                        )}
                        {/* FIM DESCRIÇÃO */}

                        {/* INICIO GERA PRODUCAO */}
                        <div className='row mb-3 mt-4'>
                            <div className='d-flex col-lg-12 '>
                                <label className='form-label fw-bold d-flex mb-3 mt-3 fw-bold'>
                                    Gera Produção ?
                                </label>
                                <div
                                    className='form-check form-switch form-check-custom form-check-solid fw-bold me-10'>
                                    <label className='form-check-label'>
                                        {intl.formatMessage({id: 'COMMON.NO'})}
                                        &nbsp;
                                    </label>
                                    <input
                                        className='form-check-input h-20px w-30px'
                                        type='checkbox'
                                        {...formik.getFieldProps('generate_production')}
                                    />
                                    <label className='form-check-label'>
                                        {intl.formatMessage({id: 'COMMON.YES'})}
                                    </label>
                                </div>
                            </div>
                        </div>
                        {/* FIM GERA PRODUCAO */}

                        {/*INICIO DROPZONE*/}
                        <div className='dropzone'>
                            <div {...getRootProps()}>
                                <div className='dz-message needsclick'>
                                    <i className='bi bi-file-earmark-arrow-up text-primary fs-3x'></i>
                                    <div className='ms-4'>
                                        <input {...getInputProps()} />
                                        {isDragActive ? (
                                            <h3 className='fs-7 fw-bold text-gray-900 mb-1'>
                                                {intl.formatMessage({id: 'DROPZONE.TITLE_DRAG'})}
                                            </h3>
                                        ) : (
                                            <h3 className='fs-7 fw-bold text-gray-900 mb-1'>
                                                {intl.formatMessage({id: 'DROPZONE.TITLE_GENERIC'})}
                                            </h3>
                                        )}
                                        <label htmlFor='license_documentation' className='fs-8 fw-semibold text-gray-400'>
                                            {intl.formatMessage({id: 'DROPZONE.SUBTITLE_GENERIC'})}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            {active ? (
                                <p> {files}</p>
                            ) : ('')}
                        </div>
                        {/*FIM DROPZONE*/}


                        <div className='row mb-3'>
                            {/* INICIO LARGURA ICONE */}
                            <div className='col-lg-6'>
                                <label className='col-form-label fw-bold '>
                                    {intl.formatMessage({id: 'COMMON.INPUT_WIDTH_ICON'})}
                                </label>

                                <input
                                    type='number'
                                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                    placeholder={intl.formatMessage({id: 'COMMON.PLACEHOLDER_INPUT_WIDTH_ICON'})}
                                    {...formik.getFieldProps('icon_width')}
                                />
                            </div>
                            {/* FIM LARGURA ICONE */}

                            {/* INICIO ALTURA ICONE */}
                            <div className='col-lg-6'>
                                <label className='col-form-label fw-bold '>
                                    {intl.formatMessage({id: 'COMMON.INPUT_HEIGHT_ICON'})}
                                </label>

                                <input
                                    type='number'
                                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                    placeholder={intl.formatMessage({id: 'COMMON.PLACEHOLDER_INPUT_HEIGHT_ICON'})}
                                    {...formik.getFieldProps('icon_height')}
                                />
                            </div>
                        </div>
                        {/* FIM ALTURA ICONE */}

                        {/*INICIO BOTOES SALVAR/LIMPAR */}
                        <div className='d-flex justify-content-end py-6'>

                            <button type='submit' className='btn btn-primary' disabled={loading}>
                                {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                                {loading && (
                                    <span className='indicator-progress' style={{display: 'block'}}>
                                        {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                    </span>
                                )}
                            </button>

                            <button
                                type='reset'
                                onClick={resetInputs}
                                className='btn btn-secondary mx-2'>
                                {intl.formatMessage({id: 'COMMON.CLEAR_BUTTON'})}
                            </button>

                        </div>
                        {/*FIM BOTOES SALVAR/LIMPAR */}
                    </div>
                </form>
            </div>
        </div>
    )
}

export {FormEnterprisesTypeAdd}
